import React, { useRef, useState } from 'react';
import {Link} from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import PageBanner from '../layout/PageBanner';
import WithUs from '../components/WithUs';
import TestimonialBlog from '../components/TestimonialBlog';
import TouchStart from '../components/TouchStart';
import PriceList from "../components/PriceList";
import AccordionBlog from '../components/AccordionBlog';


const priceBlock = [
    {srid:1, title:'Beginner', price:'25',  price2:'10'},
    {srid:2, title:'Starter', price:'30',  price2:'15'},
    {srid:3, title:'Professionl', price:'50',  price2:'30'},
    {srid:4, title:'Power Plan', price:'65',  price2:'45'},
];


const Pricing = () => {
    const { t } = useTranslation();
    const [changeValue, setChangeValue] = useState(false)
    const inputRef = useRef<HTMLInputElement>(null);
    const [activePrice, setActivePrice] = useState(2)
    return (
        <>
            <PageBanner parentPage={t('pricingPage.parentPage')} activePage={t('pricingPage.activePage')} motherMenu={t('pricingPage.motherMenu')} />
            <section className="main-pricing page-pricing">
                <div className="container">
                    <div className='row'>
                        <PriceList></PriceList>
                    </div>

                </div>
            </section>
            <section className="main-with-us">
                <WithUs />
            </section>  
            <section className="main-testimonial">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="center-title">
                                <span className="sub-title">{t('pricingPage.testimonialSubtitle')}</span>
                                <h2 className="h2-title">{t('pricingPage.testimonialTitle')}</h2>
                            </div>
                        </div>
                    </div>
                    <TestimonialBlog /> 
                </div>
            </section>            
            <section className="main-contact page-inner-contact">
                <div className="container">
                    <TouchStart />
                </div>
            </section>

            {/* FAQ Section Start */}
            <section className="main-faq-content" style={{ background: '#ffffff' }}>
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-12">
                            <div className="center-title">
                                <span className="sub-title">{t('home.faqSubtitle')}</span>
                                <h2 className="h2-title">{t('home.faqTitle')}</h2>
                            </div>
                            <div className="faq-accordion accordion-style">
                                <div className="row">
                                    <div className="col-lg-10 offset-lg-1">
                                        <AccordionBlog arrayData={[
                                            { title: t('faqPage.q14'), content: t('faqPage.a14') },
                                            { title: t('faqPage.q12'), content: t('faqPage.a12') },
                                            { title: t('faqPage.q2'), content: t('faqPage.a2') },
                                            { title: t('faqPage.q4'), content: t('faqPage.a4') },
                                            { title: t('faqPage.q11'), content: t('faqPage.a11') },
                                            { title: t('faqPage.q15'), content: t('faqPage.a15') },
                                        ]} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default Pricing;